export const regenTimeLimit = 30;

export const genericErrMsg = 'Something went wrong. Please try again';
